/* Direct Hit cart upsell: "Keep your Direct Hit running" spares in the cart drawer and on /cart.
 * Data: <script id="dh-upsell-data"> from snippets/jps-direct-hit-upsell.liquid (SKU -> live variant).
 * Only active, available spares appear, so draft products stay hidden until they are activated.
 * Hooks: theme event "jps:cart:updated" (detail = cart.js) and window.JPS_addToCart(variantId, qty, props). */
(function (root) {
  'use strict';

  var H = 'direct-hit-';
  // Per nozzle: suggestions in priority order. INS = rear inserts from the build, HEAD = service kit for the built head.
  var RULES = {};
  RULES[H + 'c33rs-extra-short-penetrator'] = ['INS', '300-276-020', '300-271-031'];
  RULES[H + 'c38rs-extreme-short-penetrator'] = ['INS', '300-450-020', '300-330-071'];
  RULES[H + 'c38rs-hd-heavy-duty-penetrator'] = ['INS', '300-263-020', '300-330-071'];
  RULES[H + 'c43rs-short-penetrator'] = ['INS', '300-635-020', '300-740-241'];
  RULES[H + 'c43rs-hd-heavy-duty-penetrator'] = ['INS', '300-568-020', '300-740-241'];
  RULES[H + 'c33ds30-cutter'] = ['HEAD'];
  RULES[H + 'dc38-extreme-cutter'] = ['HEAD', '300-800-020', '300-750-004'];
  RULES[H + 'dc43-extreme-cutter'] = ['HEAD', '300-800-021', '300-750-006'];
  RULES[H + 'combo-38-penetrator-cutter'] = ['INS', 'HEAD', '300-450-020', '300-800-020'];
  RULES[H + 'combo-43-penetrator-cutter'] = ['INS', 'HEAD', '300-635-020', '300-800-021'];
  RULES[H + 'ndd-hydrox-hd-hydro-excavation-nozzle-head'] = ['HEAD', '300-750-064'];

  // Fallback inserts when a penetrator line has no build (e.g. added before the jetting check existed).
  var DEFAULT_INS = {};
  DEFAULT_INS[H + 'c33rs-extra-short-penetrator'] = '300-749-911';
  ['c38rs-extreme-short-penetrator', 'c38rs-hd-heavy-duty-penetrator', 'c43rs-short-penetrator', 'c43rs-hd-heavy-duty-penetrator']
    .forEach(function (h) { DEFAULT_INS[H + h] = 'J-M6JET-09'; });

  // Head part in the build -> matching service kit SKU.
  var HEAD_KIT = [
    [/^300-324-0(\d\d)$/, '300-424-0'],  // DC38 head -> 38 mm repair kit
    [/^300-530-0(\d\d)$/, '300-635-0'],  // DC43 head -> 43 mm short rotor kit
    [/^300-100-0(\d\d)$/, '300-250-0'],  // Hydro-X head -> HD-18 short rotor kit
    [/^300-277-0(\d\d)$/, '300-277-0']   // C33DS30 head kit -> same kit as a spare
  ];
  var INSERT = /^(J-M6JET-[\d.]+|300-749-91\d)$/;
  var MAX = 4;

  function buildParts(line) {
    var out = [], p = line.properties || {};
    Object.keys(p).forEach(function (k) {
      if (k.indexOf('Build Parts') !== 0) return;
      String(p[k]).replace(/([A-Z0-9][A-Z0-9.\-]*[A-Z0-9]) x (\d+)/g, function (m, code, qty) { out.push([code, +qty]); return m; });
    });
    return out;
  }

  // Pure: cart + data -> [{sku, qty, reason, v}] (exported for tests).
  function suggest(cart, data) {
    var inCart = {}, seen = {}, list = [];
    (cart.items || []).forEach(function (l) { if (l.sku) inCart[l.sku] = true; inCart['v' + l.variant_id] = true; });
    function add(sku, qty, reason) {
      var v = data[sku];
      if (!v || !v.available || inCart[sku] || inCart['v' + v.id] || seen[sku]) return;
      seen[sku] = true;
      list.push({ sku: sku, qty: qty || 1, reason: reason, v: v });
    }
    (cart.items || []).forEach(function (l) {
      var rule = RULES[l.handle];
      if (!rule) return;
      var parts = buildParts(l), model = l.product_title.replace(/^Direct Hit\s+/, '').split(/\s+/)[0];
      rule.forEach(function (r) {
        if (r === 'INS') {
          var ins = parts.filter(function (p) { return INSERT.test(p[0]); });
          if (ins.length) ins.forEach(function (p) { add(p[0], p[1], 'Spare set of rear jets for your ' + model); });
          else if (DEFAULT_INS[l.handle]) add(DEFAULT_INS[l.handle], 3, 'Spare rear jets for your ' + model + ' (confirm size)');
        } else if (r === 'HEAD') {
          parts.forEach(function (p) {
            HEAD_KIT.forEach(function (m) { var x = p[0].match(m[0]); if (x) add(m[1] + x[1], 1, 'Service kit for the head in your ' + model); });
          });
        } else {
          add(r, 1, 'Wear part for your ' + model);
        }
      });
    });
    return list.slice(0, MAX);
  }

  var engine = { suggest: suggest, buildParts: buildParts, RULES: RULES };
  if (typeof module !== 'undefined' && module.exports) { module.exports = engine; return; }
  root.JPSDirectHitUpsell = engine;

  var doc = root.document, data = null;
  try { data = JSON.parse(doc.getElementById('dh-upsell-data').textContent); } catch (e) { return; }
  if (!data || !Object.keys(data).length) return;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { return root.JPS_money ? root.JPS_money(Math.round(n * 100)) : '$' + Number(n).toFixed(2); }

  function css() {
    if (doc.getElementById('dhu-css')) return;
    var s = doc.createElement('style');
    s.id = 'dhu-css';
    s.textContent =
      '.dhu{margin:10px 16px 12px;padding:12px;border:1px solid #d7e2f0;border-radius:10px;background:#f6f9fd}' +
      '.dhu h4{margin:0 0 2px;font-size:14px;color:#0f1d34}.dhu .dhu-sub{margin:0 0 8px;font-size:12px;color:#52647a}' +
      '.dhu-row{display:flex;gap:10px;align-items:center;padding:8px 0;border-top:1px solid #e3eaf3}' +
      '.dhu-row:first-of-type{border-top:0}.dhu-img{flex:0 0 48px;height:48px;border-radius:6px;background:#fff;object-fit:contain;border:1px solid #e3eaf3}' +
      '.dhu-info{flex:1;min-width:0;font-size:13px;line-height:1.3}.dhu-info a{color:#0f1d34;font-weight:700;text-decoration:none}' +
      '.dhu-info .dhu-why{color:#52647a;font-size:12px}.dhu-info .dhu-price{font-weight:700;color:#164f9c}' +
      '.dhu-add{flex:0 0 auto;min-height:40px;min-width:64px;padding:6px 12px;border:1px solid #2458a4;border-radius:7px;background:#fff;color:#164f9c;font-weight:700;font-size:13px;cursor:pointer}' +
      '.dhu-add:hover{background:#2458a4;color:#fff}.dhu-add:disabled{opacity:.5;cursor:wait}' +
      '.dhu-page{margin:16px 0}.dhu-drawer{margin:12px 0}';
    doc.head.appendChild(s);
  }

  function html(list) {
    return '<h4>Keep your Direct Hit running</h4><p class="dhu-sub">Genuine spares that match what is in your cart.</p>' +
      list.map(function (s) {
        var v = s.v, name = v.product.replace(/\s+[—-]\s+.*$/, '') + (v.option && v.option !== 'Default Title' ? ' · ' + v.option : '');
        return '<div class="dhu-row">' +
          (v.image ? '<img class="dhu-img" src="' + esc(v.image) + '" alt="" loading="lazy">' : '<span class="dhu-img"></span>') +
          '<div class="dhu-info"><a href="' + esc(v.url) + '">' + esc(name) + '</a><div class="dhu-why">' + esc(s.reason) + '</div>' +
          '<span class="dhu-price">' + money(v.price / 100) + (s.qty > 1 ? ' each · add ' + s.qty : '') + '</span></div>' +
          '<button type="button" class="dhu-add" data-dhu-id="' + v.id + '" data-dhu-qty="' + s.qty + '">Add</button></div>';
      }).join('');
  }

  function mount(cart) {
    var list = suggest(cart || {}, data);
    var drawerItems = doc.getElementById('drawerItems');
    var onCartPage = /^\/cart\/?$/.test(root.location.pathname);
    var targets = [];
    // Inside the scrolling item list, right after the last cart line (renderCart rebuilds the list, then fires the event).
    if (drawerItems) targets.push(['dhuDrawer', function (b) {
      var lines = drawerItems.querySelectorAll('.ditem'), last = lines[lines.length - 1];
      if (last) last.parentNode.insertBefore(b, last.nextSibling); else drawerItems.appendChild(b);
    }, ' dhu-drawer']);
    if (onCartPage) {
      var form = doc.querySelector('main form[action="/cart"], form[action="/cart"]');
      if (form) targets.push(['dhuPage', function (b) { form.parentNode.insertBefore(b, form.nextSibling); }, ' dhu-page']);
    }
    targets.forEach(function (t) {
      var box = doc.getElementById(t[0]);
      if (!list.length) { if (box) box.remove(); return; }
      if (!box) { box = doc.createElement('div'); box.id = t[0]; box.className = 'dhu' + t[2]; t[1](box); }
      box.innerHTML = html(list);
    });
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dhu-add');
    if (!b || b.disabled || b.dataset.cartPending === "true" || b.dataset.cartUncertain === "true") return;
    b.disabled = true;
    b.dataset.cartPending = "true";
    var id = +b.getAttribute('data-dhu-id'), qty = +b.getAttribute('data-dhu-qty') || 1;
    var p = root.JPS_addToCart ? root.JPS_addToCart(id, qty) : Promise.resolve({status:'rejected'});
    Promise.resolve(p).catch(function(){return {status:'uncertain'};}).then(function(result){
      b.dataset.cartPending = "false";
      b.dataset.cartUncertain = !result || result.status === 'uncertain' ? "true" : "false";
      b.disabled = b.dataset.cartUncertain === "true" || (result && result.status === 'added');
      if(result && result.status === 'added' && /^\/cart\/?$/.test(root.location.pathname))root.location.reload();
    });
  });

  css();
  doc.addEventListener('jps:cart:updated', function (e) { mount(e.detail); });
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(mount).catch(function () {});
})(typeof window !== 'undefined' ? window : this);